
























































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { Moment } from 'moment';
import BulkSearchModal from '@/views/components/bulkSearchModal/index.vue';
import ListMixins from './mixins/listMixins';
import DetailModal from './detailModal.vue';
import util from '@/utils/util';

const detailModalCom = util.mountVueComponent(DetailModal);

@Component({
  components: {
    BulkSearchModal,
  },
})
export default class TransportLabelManagePage extends Mixins(ListMixins) {
  /** 入库单的状态列表 */
  private get statusList(): TypeBase.StatusEnumListItem[] {
    return ([{
      text: this.t('全部'),
      value: -1,
      total: 0,
    }] as TypeBase.EnumListItem[]).concat(this.shippingMarkStatusEnum);
  }
  @Watch('datetimeDefaultValue', { immediate: true })
  private onDatetimeDefaultValueChange(arr: Moment[]): void {
    if (arr.length) {
      this.searchData.date_arr = [this.$util.formatDateTime(arr[0]), this.$util.formatDateTime(arr[1])];
    } else {
      this.searchData.date_arr = [];
    }
  }
  /**
   * @description: 搜索
   * @return {*}
   */
  private async handleSearch(): Promise<void> {
    const value = this.docValue ? this.docValue.split(',') : [];
    this.searchData.page_index = 1;
    this.searchData.code_value = value;
    await this.getList();
  }
  /**
   * @description: 双击查询
   * @return {*}
   */
  private handleDblClick(): void {
    const bulkSearchRef = this.$refs.bulkSearchModal as any;
    bulkSearchRef.modalVisible = true;
    bulkSearchRef.bulkListStr = this.docValue;
  }
  /**
   * @description: 分页切换
   * @return {*}
   */
  private handlePageChange(page: number, pageSize: number): void {
    this.searchData.page_index = page;
    this.searchData.page_size = pageSize;
    this.getList();
  }
  /**
   * @description: 批量查询
   * @return {*}
   */
  private handleBulkFeedback(bulkKeywords: string): void {
    this.docValue = bulkKeywords;
  }
  /**
   * 导出全部
   */
  private handleExportAll(): void {

    const params = this.$util.deepCopy(this.searchParams);
    delete params.page_index;
    delete params.page_size;
    this.export(params);
  }
  /**
   * 导出已选
   */
  private handleExportSelected(): void {
    if (!this.selectedList.length) {
      this.$message.warn(this.t('common', this.$config.exportSelectedEmptyTip));
    } else {
      this.export(
        {
          code_type: this.$enum.transportOrder.LabelManageSearchCodeTypeEnum.SHIPPING_MARK_NUMBER,
          code_value: this.selectedList,
        }
      );
    }
  }
  private handleStatusChange() {
    this.getList();
  }
  private handleClear() {
    this.docValue = '';
    this.searchData = this.initSearchData();
    const defaultTime = this.$util.getDefaultTimeCondition(this.$enum.common.TimePeriodEnum.THREE_MONTH);
    this.datetimeDefaultValue = defaultTime;
    this.searchData.date_arr = [this.$util.formatDateTime(defaultTime[0]), this.$util.formatDateTime(defaultTime[1])];
    this.getList();
  }
  /**
   * @description: 箱唛详情
   * @param {*} data
   * @return {*}
   */
  private handleShowDetail(data: TypeTransportOrderLabelManage.ListItem) {
    detailModalCom({
      parent: this,
      propsData: {
        code: data.shipping_mark_number,
      },
    });
  }

  private created() {
    this.initColumns();
    this.rowSelection = {
      selectedRowKeys: [],
      onChange: (selectedRowKeys: string[]) => {
        this.rowSelection.selectedRowKeys = this.selectedList = selectedRowKeys;
      },
    };
    this.$nextTick(() => {
      this.getList();
    });
  }
}
